module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/1-69231112586f1b7d6a95a9ec9927b2b7.svg";